import PropTypes from 'prop-types';
import React from 'react';
import Letter from './letter';

const CustomersFilter = ({ selectedLetter, letters, selectLetter }) => {
  const isSelected = letter => letter.toUpperCase() === selectedLetter;

  const filters = letters.map(letter => (
    <Letter
      key={letter.letter}
      letter={letter.letter}
      selectLetter={selectLetter}
      selected={isSelected(letter.letter)}
      enabled={letter.enabled}
    />
  ));

  return (
    <ul className="c-letters">
      { filters }
    </ul>
  );
};

CustomersFilter.propTypes = {
  selectLetter: PropTypes.func.isRequired,
  selectedLetter: PropTypes.string,
  letters: PropTypes.arrayOf(PropTypes.object),
};

export default CustomersFilter;
